import { FC } from 'react';
import './introduction.scss';
import compareImg from '../../public/introduction-compare-results-xref.png';
import searchImg from '../../public/introduction-search-img.png';
import { useTranslation } from 'react-i18next';
import { getLangSite, validateForChineseLanguage } from '../../ultils';

export const Introduction: FC = () => {
  const { t } = useTranslation();
  return (
    <div className="w-full md:w-1/2">
      <div className="dk-card p-2 mt-2">
        {validateForChineseLanguage(getLangSite('en')) ? (
          <div className="introduction-container pb-1">
            <div
              style={{
                display: 'block',
                position: 'relative',
                maxWidth: '1160px',
                width: '100%'
              }}
            >
              <div style={{ paddingTop: '56.2504%' }}>
                <video
                  data-video-id="6322053627112"
                  data-account="1571595843001"
                  data-player="41ecSd4l2x"
                  data-embed="default"
                  data-application-id=""
                  className="video-js"
                  controls
                  style={{
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    top: '0px',
                    bottom: '0px',
                    right: '0px',
                    left: '0px'
                  }}
                ></video>
              </div>
            </div>
          </div>
        ) : null}
        <div className="introduction-items">
          <div className="introduction-search">
            <p className="introduction-header">1. {t('xref-search')}</p>
            <p>
              {t('xref-introduction-search-1')}
              {t('xref-introduction-search-2')}
            </p>
            <div className="img-desc img-search">
              <img src={searchImg} alt="" className="w-full" />
            </div>
          </div>
          <div className="introduction-compare">
            <p className="introduction-header">
              2. {t('xref-introduction-compare')}
            </p>
            <p>
              {t('xref-introduction-compare-1')}
              {t('xref-introduction-compare-2')}
            </p>
            <div className="img-desc img-compare">
              <img src={compareImg} alt="" className="w-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
